import { inject, observer } from 'mobx-react'
import React from 'react'


@inject('workAreaStore', 'sidebarStore', 'photoStore') @observer
class FilterSlide extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      filterInputs: [
        {
          id: 'opacity',
          value: 0,
          min: 0,
          max: 100
        },
        {
          id: 'brightness',
          value: 0,
          min: -100,
          max: 100
        },
        {
          id: 'contrast',
          value: 0,
          min: -100,
          max: 100
        },
        {
          id: 'saturation',
          value: 0,
          min: -100,
          max: 100
        },
        {
          id: 'blur',
          value: 0,
          min: 0,
          max: 100
        }
      ]
    }
  }

  syncValues(){
    let layer = this.props.workAreaStore.getSelectedLayer()
    if(this.props.sidebarStore.pageFilters){
      layer = this.props.workAreaStore.pages.find(({ id }) => id === this.props.workAreaStore.activePage)
    }
    if(!layer){
      return
    }
    if((!layer || layer.type !== 'photo') && !this.props.sidebarStore.pageFilters){
      return
    }
    const { filters } = layer
    const inputs = [...this.state.filterInputs]
    Object.keys(filters).forEach(key => {
      if(key === 'noise'){
        return
      }
      const idx = inputs.findIndex(({ id }) => id === key)
      inputs[idx].value = filters[key]
    })
    this.setState({
      filterInputs: inputs
    })
  }

  componentDidMount(){
    this.syncValues()
  }

  componentDidUpdate(prevProps){
    if(prevProps.layerId !== this.props.layerId){
      this.syncValues()
    }
    if(prevProps.layer && prevProps.layer !== this.props.layer){
      this.syncValues()
    }
    if(prevProps.page && this.props.sidebarStore.pageFilters && prevProps.page !== this.props.page){
      this.syncValues()
    }
  }

  handleSliderChange(e, isForm){
    const { name, value } = e.target
    const copy = [...this.state.filterInputs]
    const idx = copy.findIndex(({ id }) => id === name)
    let v = Number(value) + 100
    let val = Number(value)
    if(name === 'opacity' || name === 'blur'){
      v = Number(value)
    }
    if(isForm){
      const max = Number(e.target.max)
      const min = Number(e.target.min)
      if(val > max){
        v = max + 100
        e.target.value = max
      }
      if(val < min){
        v = min + 100
        e.target.value = min
      }
      if(name === 'opacity' || name === 'blur' && val > max){
        v = 100
      }
    }
    copy[idx].value = v
    this.setState({ filterInputs: copy })
    const { workAreaStore } = this.props
    if(this.props.sidebarStore.pageFilters){
      workAreaStore.changePageProp(this.props.workAreaStore.activePage, `filters|${name}`, v)
    }else{
      workAreaStore.changeFilterProp(this.props.layerId, name, v)
    }
  }

  finishHandlerChange(){
    const { workAreaStore } = this.props
    workAreaStore.appendToHistory()
  }

  resetAll(){
    const { workAreaStore, sidebarStore } = this.props
    const copy = this.state.filterInputs.map(input => {
      let obj = {
        ...input,
        value: 100
      }
      if(input.id === 'blur'){
        obj = {
          ...input,
          value: 0
        }
      }
      if(sidebarStore.pageFilters){
        const propName = `filters|${input.id}`
        if(input.id === 'blur'){
          workAreaStore.changePageProp(workAreaStore.activePage, propName, 0)
          return obj
        }
        workAreaStore.changePageProp(workAreaStore.activePage, propName, 100)
        return obj
      }else{
        if(input.id === 'blur'){
          workAreaStore.changeFilterProp(workAreaStore.selectedLayer, input.id, 0)
          return obj
        }
        workAreaStore.changeFilterProp(workAreaStore.selectedLayer, input.id, 100)
        return obj
      }
    })
    this.setState({
      filterInputs: copy
    })
  }

  resetFilter(propName){
    const { workAreaStore, sidebarStore } = this.props
    const copy = [...this.state.filterInputs]
    let newValue = 100
    if(propName === 'blur'){
      newValue = 0
    }
    const idx = copy.findIndex(({ id }) => id === propName)
    copy[idx].value = newValue
    this.setState({ filterInputs: copy })
    if(sidebarStore.pageFilters){
      workAreaStore.changePageProp(workAreaStore.activePage, `filters|${propName}`, newValue)
    }else{
      workAreaStore.changeFilterProp(workAreaStore.selectedLayer, propName, newValue)
    }
  }

  getFilterSliders(){
    return this.state.filterInputs.map((input, key) => {
      const { id, min, max, value } = input
      let val = value - 100
      if(id === 'opacity'){
        val = value
      }
      if(id === 'blur'){
        val = value
      }
      return (
        <div className='filters__input row no-gutters' key={id}>
          <div className='col-3'>
            <span className='filters__input__title'>{id}</span>
          </div>
          <div className='col-7 filters__input__slider'>
            <input
              type='range'
              className='slider'
              name={id}
              min={min}
              max={max}
              value={val}
              onChange={e => this.handleSliderChange(e)}
              onMouseUp={(e) => this.finishHandlerChange(e)}
              style={{
                //backgroundSize: (val - min) * 100 / (max - min) + '% 100%'
                backgroundImage: 'none'
              }}
              onDoubleClick={() => this.resetFilter(id)}
            />
          </div>
          <div className='col-2 prop-col'>
            <input 
              className='filters__input__prop form-control'
              value={val}
              type='number'
              min={min}
              max={max}
              name={id}
              onChange={e => this.handleSliderChange(e, true)}
              onKeyUp={(e) => this.finishHandlerChange(e)}
            />
          </div>
        </div>
      )
    })
  }

  render(){
    return (
      <div className='slide-wrapper'>
        <div className='filters'>
          <div className='filters__input-wrapper'>
            <div className='filters__reset-col'>
              <span className='filters__reset-btn cursor-pointer' onClick={() => this.resetAll()}>
                Reset
              </span>
            </div>
            {
              this.getFilterSliders()
            }
          </div>
        </div>
      </div>
    )
  }

}

export default FilterSlide